'use strict';
const deepAssign = require('../deep-assign'),
	dereference = require('./dereference'),
	isObjectObject = require('@mindmup/js-utils/src/is-object-object'),
	deepFreeze = require('../util/deep-freeze'),
	themeToDictionary = require('./theme-to-dictionary'),
	calculateNodeOrder = require('./calculate-node-order');
module.exports = function mergeThemesV2(params) {
	if (!params) {
		throw new Error('invalid-args');
	}
	const {defaultTheme, selectedTheme, themeOverride} = params,
		calculateOverrides = () => {
			if (!themeOverride) {
				return {};
			}
			if (selectedTheme && selectedTheme.blockThemeOverrides) {
				return {};
			}
			return themeToDictionary(themeOverride);
		},
		deepCopy = themeJSON => JSON.parse(JSON.stringify(themeJSON)),
		mergeJSON = () => {
			if (!defaultTheme || !isObjectObject(defaultTheme)) {
				throw new Error('invalid-args');
			}
			if (!selectedTheme && !themeOverride) {
				return Object.assign(themeToDictionary(defaultTheme), {nodeOrder: calculateNodeOrder([defaultTheme])});
			}
			const beforeOverrides = deepAssign(themeToDictionary(defaultTheme), themeToDictionary(selectedTheme || {})),
				beforeOverridesDereferenced = dereference({prefix: 'base:', target: deepCopy(beforeOverrides)});
			return deepAssign(beforeOverridesDereferenced, calculateOverrides(), {nodeOrder: calculateNodeOrder([defaultTheme, selectedTheme, themeOverride])});
		};

	return deepFreeze(dereference({prefix: 'theme:', target: deepCopy(mergeJSON())}));
};
